import { render, staticRenderFns } from "./reportGoods.vue?vue&type=template&id=4c1ec544&scoped=true&"
import script from "./reportGoods.vue?vue&type=script&lang=js&"
export * from "./reportGoods.vue?vue&type=script&lang=js&"
import style0 from "./reportGoods.vue?vue&type=style&index=0&id=4c1ec544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1ec544",
  null
  
)

export default component.exports